const trackedActions = {
    'UI/STORIES_LIST/OPEN': () => ( {
        category: 'UI Interaction',
        action: 'Opened stories list',
    } ),
}

export default trackedActions
